import { create } from 'zustand';

interface FormGuardState {
  isAnyFormDirty: boolean;
  setAnyFormDirty: (isDirty: boolean) => void;
}

/**
 * Global store to track if any form in any sub-route is currently dirty.
 * Used for top-level visual cues in the SystemLayout.
 */
export const useFormGuardStore = create<FormGuardState>((set) => ({
  isAnyFormDirty: false,
  setAnyFormDirty: (isDirty) => set({ isAnyFormDirty: isDirty }),
}));
